export const routerRoles = [
    {
        path: '/permission',
        name: 'Roles',
        meta: {
            authRequired: true,
            roleDefault: '',
            role: ['permission.view'],
            typeRouterForm: false,
            titleJP: '権限管理一覧',
            pageNames: [
                {
                    text: 'ダッシュボード',
                    href: '/'
                },
                {
                    text: '権限管理一覧',
                    active: true
                }
            ]
        },
        component: () => import('@/views/pages/roles')
    }
];
